__turbopack_context__.v({
  "dropdown_container": "styles-module-scss-module__tQRzvW__dropdown_container",
  "dropdown_content": "styles-module-scss-module__tQRzvW__dropdown_content",
  "dropdown_content_inner": "styles-module-scss-module__tQRzvW__dropdown_content_inner",
  "options_container": "styles-module-scss-module__tQRzvW__options_container",
  "sort_button": "styles-module-scss-module__tQRzvW__sort_button",
});
